import type { FC } from "react";

import type { ISite } from "@similarweb/ui-components";

import WebsiteQueryBar from "app/components/compare/WebsiteQueryBar/WebsiteQueryBar";
import { EmptyWebsiteQueryBar } from "app/components/compare/WebsiteQueryBar/EmptyWebsiteQueryBar";
import { EducationContainer } from "app/components/educationbar/educationContainer";
import educationHook from "app/components/educationbar/educationHook";
import PageTitle from "app/components/React/PageTitle/PageTitle";
import { SubNav } from "app/components/sub-navigation-bar/SubNav";
import { BacklinksSubNavFilters } from "app/pages/digital-marketing/backlinks/frame/BacklinksSubNavFilters";

import { useExpectedBacklinksParams } from "../shared/BacklinksUtils";

// This function filters out items that have a "mainSite" property
// Items that include the mainSite are items with compare items
// Backlinks does not support compare items at this point
// So we need to filter them out
function getFilteredSingleItems<T extends ISite>(listItems: T[]) {
    return listItems.filter((item) => !("mainSite" in item));
}

export const BacklinksSubNav: FC = () => {
    const params = useExpectedBacklinksParams();
    const [showEducationIcon, showEducationBar, setValues] = educationHook();

    const onEducationIconClick = () => {
        setValues(false, true);
    };
    const onCloseEducationBar = () => {
        setValues(true, false);
    };

    if (!params.key) {
        return (
            <SubNav
                topLeftComponent={<EmptyWebsiteQueryBar filterListItems={getFilteredSingleItems} />}
                bottomLeftComponent={
                    <PageTitle
                        showEducationIcon={showEducationIcon}
                        onEducationIconClick={onEducationIconClick}
                    />
                }
            />
        );
    }

    return (
        <SubNav
            topLeftComponent={
                <WebsiteQueryBar
                    overrideCompareButton={true}
                    renderFavoriteButton={() => null}
                    filterListItems={getFilteredSingleItems}
                />
            }
            bottomRightComponent={<BacklinksSubNavFilters />}
            bottomLeftComponent={
                <PageTitle
                    showEducationIcon={showEducationIcon}
                    onEducationIconClick={onEducationIconClick}
                />
            }
            education={showEducationBar ? <EducationContainer onCloseEducationComponent={onCloseEducationBar} /> : null}
        />
    );
};
